type Props = {
  title: string
  description: string
}

export function PlaceholderPage({ title, description }: Props) {
  return (
    <div className="card">
      <h2 style={{ margin: 0, fontSize: 18 }}>{title}</h2>
      <p style={{ margin: '8px 0 0', color: 'var(--n-500)', lineHeight: 1.6 }}>
        {description}
      </p>
    </div>
  )
}
